const detail = {
  customerInfo: [
    {
      name: 'customerNumber',
      text: 'sale.sale_customer-number'
    },
    {
      name: 'customerName',
      text: 'user.user_customer-name'
    },
    {
      name: 'alphabet',
      text: 'common.common_alphabet-pit-in'
    },
    {
      name: 'customerCategoryId',
      text: 'common.input_customer-category',
      component: 'SelectCustomerCategory'
    },
    {
      name: 'organizationName',
      text: 'common.common_company-department'
    },
    {
      name: 'shopName',
      text: 'jd.jd_store-name'
    },
    {
      name: 'paymentCriteria',
      text: 'common.input_payment-criteria'
    },
    {
      name: 'billingName',
      text: 'common.input_billing-info'
    },
    {
      name: 'payeeInfo',
      text: 'common.input_recipient-info'
    }
  ]
}

export default { detail }
